

export class ImageSlider {

  constructor(container) {
    this.container = container;
    this.init();
  }

  init() {
    this.interval = parseInt(this.container.dataset.interval, 10);
    this.handler = this.switch.bind(this);
    setTimeout(this.handler, this.interval);
  }

  switch() {
    const prev = this.container.querySelector('.prev');
    const current = this.container.querySelector('.current');
    const next = this.container.querySelector('.next');
    let theOneAfterNext = this.container.querySelector('.next + img');

    if (!theOneAfterNext) {
      theOneAfterNext = this.container.querySelector('img');
    }

    next.classList.add('current');
    next.classList.remove('next');
    current.classList.add('prev');
    current.classList.remove('current');

    if (theOneAfterNext) {
      theOneAfterNext.classList.add('next');

      if (theOneAfterNext.classList.contains('lazy') && theOneAfterNext.dataset.src && theOneAfterNext.dataset.src !== theOneAfterNext.src) {
        theOneAfterNext.src = theOneAfterNext.dataset.src;
        theOneAfterNext.classList.remove('lazy');
      }

    }
    if (prev) {
      prev.classList.remove('prev');
    }

    setTimeout(this.handler, this.interval);
  }
}
